import axios from "axios";
const baseURL = process.env.REACT_APP_QBEE_ENDPOINT;

const Axios = axios.create({
  baseURL,
});

export default Axios;
